import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";
import { IMapSettings } from "../../models/storeModels/IMapSettings";
import { getItemWebStorage } from "../../features/webStorageSaver";

export const auxiliaryLayersInitialDisplayState = {
    esriWorldImagery: false,
    indorAvia: false,
    allObjects: false
}

export const rosreestrLayersInitialDisplayState = {
    okrug: true,
    raion: true,
    kvartal: true,
    building: false,
    construction: false,
    unfinishedBuilding: false,
    landPlots: true,
    cultureZOUIT: false,
    serviceZOUIT: false,
    natureZOUIT: false,
    secureZOUIT: false,
    otherZOUIT: false,
    specialZOUIT: false,
    forestry: false,
    coastlinesPolygonal: false,
    coastlinesLinear: false
}

function getInitialState() {
    const localMapSettings = getItemWebStorage("mapSettings")
    const { auxiliaryLayersDisplayState, rosreestrLayersDisplayState, additionalLayersDisplayState } = localMapSettings ?? {}
    const initialState: IMapSettings = {
        auxiliaryLayersDisplayState: auxiliaryLayersDisplayState ?? auxiliaryLayersInitialDisplayState,
        rosreestrLayersDisplayState: rosreestrLayersDisplayState ?? rosreestrLayersInitialDisplayState,
        additionalLayersDisplayState: additionalLayersDisplayState ?? {}
    }
    return initialState
}

export const mapSettingsSlice = createSlice({
    name: 'mapSettings',
    initialState: getInitialState(),
    reducers: {
        setMapLayersState(state: any, action: PayloadAction<any>) {
            const { layersType, layersState } = action.payload
            state[`${layersType}LayersDisplayState`] = layersState
        },
        resetAllMapLayersState(state: any){
            state.auxiliaryLayersDisplayState = auxiliaryLayersInitialDisplayState
            state.rosreestrLayersDisplayState = rosreestrLayersInitialDisplayState
            state.additionalLayersDisplayState = {}
        },
        setMapLayersTreeSelectedKeys(state: any, action: PayloadAction<any>) {
            const { layersType, selectedKeys } = action.payload
            state[`${layersType}LayersTreeSelectedKeys`] = selectedKeys
        },
        setMapLayersOpacityState(state: any, action: PayloadAction<any>) {
            const { layersType, layersState } = action.payload
            state[`${layersType}LayersOpacityState`] = layersState
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { setMapLayersState, resetAllMapLayersState, setMapLayersTreeSelectedKeys, setMapLayersOpacityState } = mapSettingsSlice.actions
export const mapSettingsReducer = mapSettingsSlice.reducer;
